<template>
	<div>
		<p>Confirm the placement of the map pin.<br><small class="font-grey-mint">Drag the map marker to your location if the coordinates are not correct</small></p>
		<div id="map" style="margin-bottom: 25px; margin-top: 25px; height: 300px;">There was an issue loading the map. Please try again.</div>
	</div>
</template>
<script>
import GoogleMapsApiLoader from 'google-maps-api-loader'
let map,
	marker

/**
 * Google Maps Pin Confirmation module is used to confirm and update the positioning of the Google Maps pin.
 * @class GoogleMapsPinConfirmation
 * @prop {string} passedValue - Used to pass the current coordinates into the api.
 * @since 0.0.8
 */

export default {
	name: 'google-maps-pin-confirmation',
	props: {
		passedValue: {
			type: Object,
			default: {},
			required: true
		}
	},
	/**
	 * Run on `created` to initialize the Googles Maps API
	 * @function
	 * @returns {undefined}
	 * @memberof GoogleMapsPinConfirmation
	 * @version 0.0.8
	 */
	created () {
		let _this = this

		GoogleMapsApiLoader({
			libraries: ['places'],
			apiKey: 'AIzaSyBTLgkSK3g81GRBpZATw0UmxkwlbbRXwVg'
		})
		.then(googleApi => {
			const position = {lat: _this.passedValue.coordinates.lat, lng: _this.passedValue.coordinates.lng}
			map = new googleApi.maps.Map(document.getElementById('map'), {
				center: position,
				zoom: 15
			})

			marker = new googleApi.maps.Marker({
				position: position,
				map: map,
				draggable: true
			})

			marker.addListener('dragend', _this.updateMarkerLatLng)
		}, err => {
			console.error(err)
		})
	},
	methods: {
		/**
		 * To update the coordinates of the map marker.
		 * @function
		 * @param {object} val - The updated position of the map marker.
		 * @returns {undefined}
		 * @memberof GoogleMapsPinConfirmation
		 * @version 0.0.8
		 */
		updateMarkerLatLng (val) {
			let coordinates = {lat: val.latLng.lat(), lng: val.latLng.lng()}
			this.$emit('updateLocationLatLng', coordinates)
		}
	}
}
</script>


// WEBPACK FOOTER //
// GoogleMapsPinConfirmation.vue?1af02c40